import { getSplitParam } from '../../../utils';

/** Indicates if the given display set is the one specified in the
 * displaySet parameter in the URL
 * The parameters are:
 *    initialSeriesInstanceUID
 *    initialSOPInstanceUID
 */
const isDisplaySetFromUrl = (displaySet): boolean => {
  const params = new URLSearchParams(window.location.search);
  const initialSeriesInstanceUID = getSplitParam('initialseriesinstanceuid', params);
  const initialSOPInstanceUID = getSplitParam('initialsopinstanceuid', params);
  if (!initialSeriesInstanceUID && !initialSOPInstanceUID) {
    return false;
  }

  const isSeriesMatch = initialSeriesInstanceUID?.some(
    seriesUID => displaySet.SeriesInstanceUID === seriesUID
  );

  const isSopMatch = initialSOPInstanceUID?.some(sopUID =>
    displaySet.instances?.some(instance => sopUID === instance.SOPInstanceUID)
  );

  return isSeriesMatch || isSopMatch;
};

/** Returns the initial image position for a display set.
 * If the URL carries an `initialSOPInstanceUID` deep-link (the readyPackage /
 * RIS flow), open at that instance. Otherwise ALWAYS open at the FIRST image
 * ({ index: 0 }) so every series starts at image 1 and loads top→down — never
 * jumping to the middle/last slice (which made the scrollbar start low and the
 * series appear to load bottom-to-top). Astra.
 */
function sopInstanceLocation(displaySets) {
  const displaySet = displaySets?.[0];
  if (!displaySet) {
    return;
  }
  const initialSOPInstanceUID = getSplitParam('initialsopinstanceuid');
  if (!initialSOPInstanceUID) {
    return { index: 0 };
  }

  // Derived/dynamically-built display sets can lack `instances`; guard it (mirrors the
  // `displaySet.instances?.some(...)` idiom used above) so HP matching can't throw on a
  // deep-link load. `?? -1` falls into the start-at-first-image fallback below.
  const index =
    displaySet.instances?.findIndex(instance =>
      initialSOPInstanceUID.includes(instance.SOPInstanceUID)
    ) ?? -1;
  // Deep-link SOP not in this display set -> still start at the first image.
  return index === -1 ? { index: 0 } : { index };
}

export { isDisplaySetFromUrl, sopInstanceLocation };
